export default __webpack_public_path__ + "static/media/leader_notes.f6f01d23.pdf";